import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchRestaurantFooter } from "../../actions/footerActions";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import {
  useSelector,
} from "react-redux";

import {
  useCart,
} from "../../components/CartContext";

import "./css/Footer.css";


function Footer() {
  const dispatch = useDispatch();
  const footerData = useSelector((state) => state.footer?.data || {});

  const {
    restaurantId,
    tableId,
  } = useParams();


  const navigate =
    useNavigate();

  useEffect(() => {
    if (restaurantId) dispatch(fetchRestaurantFooter(restaurantId)).catch(() => {});
  }, [dispatch, restaurantId]);


  /*
  =======================================================
  RESTAURANT
  =======================================================
  */

  const themeState =
    useSelector(
      (state) => state.theme
    );


  const restaurantName = footerData.restaurant_name || themeState?.restaurantName || themeState?.restaurant_name || "Restaurant";


  const restaurantAddress = footerData.address || themeState?.address || "";


  const restaurantMobile = footerData.phone || themeState?.mobile || "";


  const restaurantEmail = footerData.email || themeState?.email || "";


  /*
  =======================================================
  CART
  =======================================================
  */

  const {
    cartCount,
  } = useCart();


  /*
  =======================================================
  HOME
  =======================================================
  */

  const handleHomeClick = () => {

    navigate(
      `/${restaurantId}/table/${tableId}`
    );

  };


  /*
  =======================================================
  SECTION
  =======================================================
  */

  const scrollToSection = (
    sectionId
  ) => {

    const element =
      document.getElementById(
        sectionId
      );


    if (element) {

      element.scrollIntoView({
        behavior:
          "smooth",

        block:
          "start",
      });

      return;

    }


    navigate(
      `/${restaurantId}/table/${tableId}`
    );

  };


  /*
  =======================================================
  CART
  =======================================================
  */

  const handleOrderClick = () => {

    navigate(
      `/${restaurantId}/table/${tableId}/cart`
    );

  };


  /*
  =======================================================
  BACK TO TOP
  =======================================================
  */

  const backToTop = () => {

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

  };


  return (

    <footer className="theme5-footer">


      {/* =================================================
          TOP BLUE SECTION
      ================================================= */}

      <div className="theme5-footer-main">

        <div className="theme5-footer-container">


          {/* =================================================
              BRAND
          ================================================= */}

          <div className="theme5-footer-brand">

            <button
              type="button"
              className="theme5-footer-logo"
              onClick={
                handleHomeClick
              }
            >

              <span>
                {restaurantName}
              </span>

              <small>
                INDIAN KITCHEN
              </small>

            </button>


            <p>
              Good food.
              Good friends.
              Good times.
            </p>


            <div className="theme5-footer-greek-line">

              <span></span>

              <b>
                NAMASTE!
              </b>

              <span></span>

            </div>

          </div>


          {/* =================================================
              EXPLORE
          ================================================= */}

          <div className="theme5-footer-column">

            <h4>
              EXPLORE
            </h4>


            <button
              type="button"
              onClick={
                handleHomeClick
              }
            >
              HOME
            </button>


            <button
              type="button"
              onClick={() =>
                scrollToSection(
                  "theme5-story"
                )
              }
            >
              OUR STORY
            </button>


            <button
              type="button"
              onClick={() =>
                scrollToSection(
                  "theme5-menu"
                )
              }
            >
              MENU
            </button>


            <button
              type="button"
              onClick={() =>
                scrollToSection(
                  "theme5-gallery"
                )
              }
            >
              GALLERY
            </button>


            <button
              type="button"
              onClick={() =>
                scrollToSection(
                  "theme5-catering"
                )
              }
            >
              CATERING
            </button>

          </div>


          {/* =================================================
              VISIT
          ================================================= */}

          <div className="theme5-footer-column">

            <h4>
              VISIT US
            </h4>


            <p>
              {restaurantAddress}
            </p>


            <p>
              MON – SUN
              <br />
              11:00 AM – 10:00 PM
            </p>


            <button
              type="button"
              onClick={() =>
                scrollToSection(
                  "theme5-contact"
                )
              }
            >
              CONTACT US
            </button>

          </div>


          {/* =================================================
              ORDER
          ================================================= */}

          <div className="theme5-footer-order">

            <span>
              HUNGRY?
            </span>


            <h3>
              LET'S EAT.
            </h3>


            <p>
              Fresh Indian flavours
              are waiting for you.
            </p>


            <button
              type="button"
              onClick={
                handleOrderClick
              }
            >

              VIEW CART

              {cartCount > 0 && (

                <strong>
                  {cartCount}
                </strong>

              )}

            </button>

          </div>

        </div>

      </div>


      {/* =================================================
          CONTACT STRIP
      ================================================= */}

      <div className="theme5-footer-contact">

        <div className="theme5-footer-container">

          <div>

            <span>
              CALL
            </span>

            <a
              href={`tel:${restaurantMobile}`}
            >
              {restaurantMobile}
            </a>

          </div>


          <div>

            <span>
              EMAIL
            </span>

            <a
              href={`mailto:${restaurantEmail}`}
            >
              {restaurantEmail}
            </a>

          </div>


          <div>

            <span>
              TABLE
            </span>

            <p>
              TABLE {tableId}
            </p>

          </div>

        </div>

      </div>


      {/* =================================================
          BOTTOM
      ================================================= */}

      <div className="theme5-footer-bottom">

        <div className="theme5-footer-container">


          <p>
            © {new Date().getFullYear()}{" "}
            {restaurantName}.
            ALL RIGHTS RESERVED.
          </p>


          <div className="theme5-footer-bottom-right">

            <span>
              MADE WITH INDIAN
              HOSPITALITY
            </span>


            <button
              type="button"
              onClick={
                backToTop
              }
            >
              BACK TO TOP ↑
            </button>

          </div>

        </div>

      </div>

      <p className="theme5-food-disclaimer" style={{textAlign:"center",padding:"12px 16px",fontSize:12}}>Food images are for presentation purposes only. Actual items may vary.</p>
    
      {/* Restaurant social profiles (only show configured HTTPS/HTTP URLs) */}
      {[
        { field: "facebook_url", label: "Facebook", glyph: "f" },
        { field: "instagram_url", label: "Instagram", glyph: "◎" },
        { field: "youtube_url", label: "YouTube", glyph: "▶" },
        { field: "whatsapp_url", label: "WhatsApp", glyph: "◉" },
      ].some(({ field }) => /^https?:\/\//i.test((footerData?.[field] || "").trim())) && (
        <nav aria-label="Restaurant social media" style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", alignItems: "center", gap: "14px", padding: "14px 18px" }}>
          {[
            { field: "facebook_url", label: "Facebook", glyph: "f" },
            { field: "instagram_url", label: "Instagram", glyph: "◎" },
            { field: "youtube_url", label: "YouTube", glyph: "▶" },
            { field: "whatsapp_url", label: "WhatsApp", glyph: "◉" },
          ].filter(({ field }) => /^https?:\/\//i.test((footerData?.[field] || "").trim())).map(({ field, label, glyph }) => (
            <a key={field} href={footerData[field].trim()} target="_blank" rel="noopener noreferrer" aria-label={label} title={label}
               style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", minWidth: "32px", minHeight: "32px", color: "inherit", textDecoration: "none", fontWeight: 700, fontSize: "20px" }}>
              {glyph}
            </a>
          ))}
        </nav>
      )}
    </footer>

  );

}


export default Footer;